import angular from 'angular';
import TravelExpenseService from './travel-expenses.service';

let travelExpenseModule = angular.module('travelexpenseservice', [
])
.service('TravelExpenseService', TravelExpenseService);

export default travelExpenseModule;



// WEBPACK FOOTER //
// ./client/common/services/travel-expenses/travel-expenses.js